import China from "./china/index";
import Province from "./province/index";
import City from "./city/index";
import SupportHospital from "./supportHospital/index";
import RecipientHospital from "./recipientHospital";
import { useSelector } from "react-redux";
import { RootState } from "@root/store";
const OverAllOverView = () => {
  const { baseUserCategory } = useSelector(
    (state: RootState) => state.userInfo
  );
  return (
    <div className="datamanager">
      {baseUserCategory === "10" && <China />}
      {baseUserCategory === "11" && <Province />}
      {baseUserCategory === "15" && <City />}
      {baseUserCategory === "13" && <SupportHospital />}
      {baseUserCategory === "12" && <RecipientHospital />}
    </div>
  );
};

export default OverAllOverView;
